type Props = {
  className?: string;
};

const IconMail = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 3H3C2.175 3 1.5075 3.675 1.5075 4.5L1.5 13.5C1.5 14.325 2.175 15 3 15H15C15.825 15 16.5 14.325 16.5 13.5V4.5C16.5 3.675 15.825 3 15 3ZM15 12.75C15 13.1625 14.6625 13.5 14.25 13.5H3.75C3.3375 13.5 3 13.1625 3 12.75V6L8.205 9.255C8.6925 9.5625 9.3075 9.5625 9.795 9.255L15 6V12.75ZM3 4.5L9 8.25L15 4.5H3Z"
      fill="#BEBEBE"
    />
  </svg>
);

export default IconMail;
